import { call, put } from "redux-saga/effects";
import { toast } from "react-toastify";
import { logger } from "utils/logger";
import { toastApiError } from "../../utils/api-error";
import { courierActions } from "../../actions/courier";
import {
  getCourierZonesAPI,
  createCourierZoneAPI,
  updateCourierZoneAPI,
  deleteCourierZoneAPI,
  reorderCourierZonesAPI,
  reorderCourierZoneCentersAPI,
  getCourierCentersAPI,
  createCourierCenterAPI,
  updateCourierCenterAPI,
  deleteCourierCenterAPI,
  getCouriersAPI,
  createCourierAPI,
  updateCourierAPI,
  getCourierRoundsAPI,
  createCourierRoundAPI,
  updateCourierRoundAPI,
  deleteCourierRoundAPI,
  getCourierRoundStopsAPI,
  createCourierRoundStopAPI,
  deleteCourierRoundStopAPI,
  reorderCourierRoundStopsAPI,
  getCourierRoundSchedulesAPI,
  createCourierRoundScheduleAPI,
  deleteCourierRoundScheduleAPI,
  getCourierShiftsAPI,
  createCourierShiftAPI,
  deleteCourierShiftAPI,
  getCourierTripsAPI,
  getCourierTripTasksAPI,
  generateCourierTripsAPI,
  getEligibleCouriersAPI,
  assignCourierTripAPI,
  cancelCourierTripAPI,
  startCourierTripAPI,
  deliverCourierTripAPI,
  reachCourierTaskAPI,
  dispatchCourierTaskAPI,
  outcomeCourierTaskAPI,
  overrideGpsCourierTaskAPI,
  getCourierCustodyItemsAPI,
  createCourierCustodyItemAPI,
  reconcileCourierCustodyItemAPI,
  createCourierManualJobAPI,
  getCourierReportsAPI,
  getCourierReportAPI,
  getCourierLiveMonitorAPI,
  optimizeCourierRoundStopsAPI,
  autoAssignCourierTripAPI
} from "../../api/courier";

// ---- Zones ----
export function* getCourierZones({ payload: values }) {
  try {
    const resp = yield call(getCourierZonesAPI, values);
    if (resp) yield put(courierActions.getCourierZonesSuccess(resp.data));
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.getCourierZonesFailure(error));
  }
}

export function* createCourierZone({ payload: data }) {
  try {
    const resp = yield call(createCourierZoneAPI, data);
    if (resp) {
      yield put(courierActions.createCourierZoneSuccess(resp.data));
      toast.success("Zone created successfully");
      yield put(courierActions.getCourierZonesRequest({}));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.createCourierZoneFailure(error));
  }
}

export function* updateCourierZone({ payload }) {
  try {
    const resp = yield call(updateCourierZoneAPI, payload);
    if (resp) {
      yield put(courierActions.updateCourierZoneSuccess(resp.data));
      toast.success("Zone updated successfully");
      yield put(courierActions.getCourierZonesRequest({}));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.updateCourierZoneFailure(error));
  }
}

export function* deleteCourierZone({ payload: id }) {
  try {
    const resp = yield call(deleteCourierZoneAPI, id);
    if (resp) {
      yield put(courierActions.deleteCourierZoneSuccess(resp.data));
      toast.success("Zone deleted successfully");
      yield put(courierActions.getCourierZonesRequest({}));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.deleteCourierZoneFailure(error));
  }
}

export function* reorderCourierZones({ payload }) {
  try {
    const resp = yield call(reorderCourierZonesAPI, payload);
    if (resp) {
      yield put(courierActions.reorderCourierZonesSuccess(resp.data));
      toast.success("Zone order updated");
      yield put(courierActions.getCourierZonesRequest({}));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.reorderCourierZonesFailure(error));
  }
}

// ---- Centers ----
export function* getCourierCenters({ payload: values }) {
  try {
    const resp = yield call(getCourierCentersAPI, values);
    if (resp) yield put(courierActions.getCourierCentersSuccess(resp.data));
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.getCourierCentersFailure(error));
  }
}

export function* createCourierCenter({ payload: data }) {
  try {
    const resp = yield call(createCourierCenterAPI, data);
    if (resp) {
      yield put(courierActions.createCourierCenterSuccess(resp.data));
      toast.success("Center created successfully");
      yield put(courierActions.getCourierCentersRequest({}));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.createCourierCenterFailure(error));
  }
}

export function* updateCourierCenter({ payload }) {
  try {
    const resp = yield call(updateCourierCenterAPI, payload);
    if (resp) {
      yield put(courierActions.updateCourierCenterSuccess(resp.data));
      toast.success("Center updated successfully");
      yield put(courierActions.getCourierCentersRequest({}));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.updateCourierCenterFailure(error));
  }
}

export function* deleteCourierCenter({ payload: id }) {
  try {
    const resp = yield call(deleteCourierCenterAPI, id);
    if (resp) {
      yield put(courierActions.deleteCourierCenterSuccess(resp.data));
      toast.success("Center deleted successfully");
      yield put(courierActions.getCourierCentersRequest({}));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.deleteCourierCenterFailure(error));
  }
}

export function* reorderCourierZoneCenters({ payload }) {
  try {
    const resp = yield call(reorderCourierZoneCentersAPI, payload);
    if (resp) {
      yield put(courierActions.reorderCourierZoneCentersSuccess(resp.data));
      toast.success("Center order updated");
      yield put(courierActions.getCourierCentersRequest({}));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.reorderCourierZoneCentersFailure(error));
  }
}

// ---- Couriers ----
export function* getCouriers({ payload: values }) {
  try {
    const resp = yield call(getCouriersAPI, values);
    if (resp) yield put(courierActions.getCouriersSuccess(resp.data));
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.getCouriersFailure(error));
  }
}

export function* createCourier({ payload: data }) {
  try {
    const resp = yield call(createCourierAPI, data);
    if (resp) {
      yield put(courierActions.createCourierSuccess(resp.data));
      toast.success("Courier created successfully");
      yield put(courierActions.getCouriersRequest({}));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.createCourierFailure(error));
  }
}

export function* updateCourier({ payload }) {
  try {
    const resp = yield call(updateCourierAPI, payload);
    if (resp) {
      yield put(courierActions.updateCourierSuccess(resp.data));
      toast.success("Courier updated successfully");
      yield put(courierActions.getCouriersRequest({}));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.updateCourierFailure(error));
  }
}

// ---- Rounds ----
export function* getCourierRounds({ payload: values }) {
  try {
    const resp = yield call(getCourierRoundsAPI, values);
    if (resp) yield put(courierActions.getCourierRoundsSuccess(resp.data));
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.getCourierRoundsFailure(error));
  }
}

export function* createCourierRound({ payload: data }) {
  try {
    const resp = yield call(createCourierRoundAPI, data);
    if (resp) {
      yield put(courierActions.createCourierRoundSuccess(resp.data));
      toast.success("Round created successfully");
      yield put(courierActions.getCourierRoundsRequest({}));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.createCourierRoundFailure(error));
  }
}

export function* updateCourierRound({ payload }) {
  try {
    const resp = yield call(updateCourierRoundAPI, payload);
    if (resp) {
      yield put(courierActions.updateCourierRoundSuccess(resp.data));
      toast.success("Round updated successfully");
      yield put(courierActions.getCourierRoundsRequest({}));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.updateCourierRoundFailure(error));
  }
}

export function* deleteCourierRound({ payload: id }) {
  try {
    const resp = yield call(deleteCourierRoundAPI, id);
    if (resp) {
      yield put(courierActions.deleteCourierRoundSuccess(resp.data));
      toast.success("Round deleted successfully");
      yield put(courierActions.getCourierRoundsRequest({}));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.deleteCourierRoundFailure(error));
  }
}

// ---- Round stops ----
export function* getCourierRoundStops({ payload: roundId }) {
  try {
    const resp = yield call(getCourierRoundStopsAPI, roundId);
    if (resp) yield put(courierActions.getCourierRoundStopsSuccess(resp.data));
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.getCourierRoundStopsFailure(error));
  }
}

export function* createCourierRoundStop({ payload }) {
  try {
    const resp = yield call(createCourierRoundStopAPI, payload);
    if (resp) {
      yield put(courierActions.createCourierRoundStopSuccess(resp.data));
      toast.success("Stop added successfully");
      yield put(courierActions.getCourierRoundStopsRequest(payload.roundId));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.createCourierRoundStopFailure(error));
  }
}

export function* deleteCourierRoundStop({ payload }) {
  try {
    const resp = yield call(deleteCourierRoundStopAPI, payload);
    if (resp) {
      yield put(courierActions.deleteCourierRoundStopSuccess(resp.data));
      toast.success("Stop removed successfully");
      yield put(courierActions.getCourierRoundStopsRequest(payload.roundId));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.deleteCourierRoundStopFailure(error));
  }
}

export function* reorderCourierRoundStops({ payload }) {
  try {
    const resp = yield call(reorderCourierRoundStopsAPI, payload);
    if (resp) {
      yield put(courierActions.reorderCourierRoundStopsSuccess(resp.data));
      toast.success("Stops reordered successfully");
      yield put(courierActions.getCourierRoundStopsRequest(payload.roundId));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.reorderCourierRoundStopsFailure(error));
  }
}

// ---- Round schedules ----
export function* getCourierRoundSchedules({ payload: values }) {
  try {
    const resp = yield call(getCourierRoundSchedulesAPI, values);
    if (resp)
      yield put(courierActions.getCourierRoundSchedulesSuccess(resp.data));
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.getCourierRoundSchedulesFailure(error));
  }
}

export function* createCourierRoundSchedule({ payload: data }) {
  try {
    const resp = yield call(createCourierRoundScheduleAPI, data);
    if (resp) {
      yield put(courierActions.createCourierRoundScheduleSuccess(resp.data));
      toast.success("Schedule created successfully");
      yield put(courierActions.getCourierRoundSchedulesRequest({}));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.createCourierRoundScheduleFailure(error));
  }
}

export function* deleteCourierRoundSchedule({ payload: id }) {
  try {
    const resp = yield call(deleteCourierRoundScheduleAPI, id);
    if (resp) {
      yield put(courierActions.deleteCourierRoundScheduleSuccess(resp.data));
      toast.success("Schedule deleted successfully");
      yield put(courierActions.getCourierRoundSchedulesRequest({}));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.deleteCourierRoundScheduleFailure(error));
  }
}

// ---- Shifts ----
export function* getCourierShifts({ payload: values }) {
  try {
    const resp = yield call(getCourierShiftsAPI, values);
    if (resp) yield put(courierActions.getCourierShiftsSuccess(resp.data));
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.getCourierShiftsFailure(error));
  }
}

export function* createCourierShift({ payload: data }) {
  try {
    const resp = yield call(createCourierShiftAPI, data);
    if (resp) {
      yield put(courierActions.createCourierShiftSuccess(resp.data));
      toast.success("Shift created successfully");
      yield put(courierActions.getCourierShiftsRequest({}));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.createCourierShiftFailure(error));
  }
}

export function* deleteCourierShift({ payload: id }) {
  try {
    const resp = yield call(deleteCourierShiftAPI, id);
    if (resp) {
      yield put(courierActions.deleteCourierShiftSuccess(resp.data));
      toast.success("Shift deleted successfully");
      yield put(courierActions.getCourierShiftsRequest({}));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.deleteCourierShiftFailure(error));
  }
}

// ---- Trips ----
export function* getCourierTrips({ payload: values }) {
  try {
    const resp = yield call(getCourierTripsAPI, values);
    if (resp) yield put(courierActions.getCourierTripsSuccess(resp.data));
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.getCourierTripsFailure(error));
  }
}

export function* getCourierTripTasks({ payload: tripId }) {
  try {
    const resp = yield call(getCourierTripTasksAPI, tripId);
    if (resp) yield put(courierActions.getCourierTripTasksSuccess(resp.data));
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.getCourierTripTasksFailure(error));
  }
}

export function* generateCourierTrips({ payload: data }) {
  try {
    const resp = yield call(generateCourierTripsAPI, data);
    if (resp) {
      yield put(courierActions.generateCourierTripsSuccess(resp.data));
      toast.success(`Generated ${resp.data.created} trip(s)`);
      yield put(courierActions.getCourierTripsRequest({}));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.generateCourierTripsFailure(error));
  }
}

export function* getEligibleCouriers({ payload: tripId }) {
  try {
    const resp = yield call(getEligibleCouriersAPI, tripId);
    if (resp) yield put(courierActions.getEligibleCouriersSuccess(resp.data));
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.getEligibleCouriersFailure(error));
  }
}

export function* assignCourierTrip({ payload }) {
  try {
    const resp = yield call(assignCourierTripAPI, payload);
    if (resp) {
      yield put(courierActions.assignCourierTripSuccess(resp.data));
      toast.success("Courier assigned successfully");
      yield put(courierActions.getCourierTripsRequest({}));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.assignCourierTripFailure(error));
  }
}

export function* cancelCourierTrip({ payload }) {
  try {
    const resp = yield call(cancelCourierTripAPI, payload);
    if (resp) {
      yield put(courierActions.cancelCourierTripSuccess(resp.data));
      toast.success("Trip cancelled");
      yield put(courierActions.getCourierTripsRequest({}));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.cancelCourierTripFailure(error));
  }
}

// ---- Operator workflow (Phase 4) ----
export function* startCourierTrip({ payload: tripId }) {
  try {
    const resp = yield call(startCourierTripAPI, tripId);
    if (resp) {
      yield put(courierActions.startCourierTripSuccess(resp.data));
      toast.success("Trip started");
      yield put(courierActions.getCourierTripsRequest({}));
      yield put(courierActions.getCourierTripTasksRequest(tripId));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.startCourierTripFailure(error));
  }
}

export function* deliverCourierTrip({ payload }) {
  try {
    const resp = yield call(deliverCourierTripAPI, payload);
    if (resp) {
      yield put(courierActions.deliverCourierTripSuccess(resp.data));
      toast.success("Trip delivered");
      yield put(courierActions.getCourierTripsRequest({}));
      yield put(courierActions.getCourierTripTasksRequest(payload.id));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.deliverCourierTripFailure(error));
  }
}

export function* reachCourierTask({ payload }) {
  try {
    const resp = yield call(reachCourierTaskAPI, payload);
    if (resp) {
      yield put(courierActions.reachCourierTaskSuccess(resp.data));
      toast.success("Marked reached");
      yield put(courierActions.getCourierTripTasksRequest(payload.tripId));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.reachCourierTaskFailure(error));
  }
}

export function* dispatchCourierTask({ payload }) {
  try {
    const resp = yield call(dispatchCourierTaskAPI, payload);
    if (resp) {
      yield put(courierActions.dispatchCourierTaskSuccess(resp.data));
      toast.success("Dispatch saved");
      yield put(courierActions.getCourierTripTasksRequest(payload.tripId));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.dispatchCourierTaskFailure(error));
  }
}

export function* outcomeCourierTask({ payload }) {
  try {
    const resp = yield call(outcomeCourierTaskAPI, payload);
    if (resp) {
      yield put(courierActions.outcomeCourierTaskSuccess(resp.data));
      toast.success("Outcome saved");
      yield put(courierActions.getCourierTripsRequest({}));
      yield put(courierActions.getCourierTripTasksRequest(payload.tripId));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.outcomeCourierTaskFailure(error));
  }
}

export function* overrideGpsCourierTask({ payload }) {
  try {
    const resp = yield call(overrideGpsCourierTaskAPI, payload);
    if (resp) {
      yield put(courierActions.overrideGpsCourierTaskSuccess(resp.data));
      toast.success("GPS override applied");
      yield put(courierActions.getCourierTripTasksRequest(payload.tripId));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.overrideGpsCourierTaskFailure(error));
  }
}

// ---- Custody & manual jobs (Phase 5) ----
export function* getCourierCustodyItems({ payload: taskId }) {
  try {
    const resp = yield call(getCourierCustodyItemsAPI, taskId);
    if (resp)
      yield put(courierActions.getCourierCustodyItemsSuccess(resp.data));
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.getCourierCustodyItemsFailure(error));
  }
}

export function* createCourierCustodyItem({ payload }) {
  try {
    const resp = yield call(createCourierCustodyItemAPI, payload);
    if (resp) {
      yield put(courierActions.createCourierCustodyItemSuccess(resp.data));
      toast.success("Custody item recorded");
      yield put(courierActions.getCourierCustodyItemsRequest(payload.taskId));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.createCourierCustodyItemFailure(error));
  }
}

export function* reconcileCourierCustodyItem({ payload }) {
  try {
    const resp = yield call(reconcileCourierCustodyItemAPI, payload);
    if (resp) {
      yield put(courierActions.reconcileCourierCustodyItemSuccess(resp.data));
      toast.success("Custody item reconciled");
      if (payload.taskId)
        yield put(courierActions.getCourierCustodyItemsRequest(payload.taskId));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.reconcileCourierCustodyItemFailure(error));
  }
}

export function* createCourierManualJob({ payload: data }) {
  try {
    const resp = yield call(createCourierManualJobAPI, data);
    if (resp) {
      yield put(courierActions.createCourierManualJobSuccess(resp.data));
      toast.success("Manual job created");
      yield put(courierActions.getCourierTripsRequest({}));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.createCourierManualJobFailure(error));
  }
}

// ---- Reports & live monitor (Phase 6) ----
export function* getCourierReports() {
  try {
    const resp = yield call(getCourierReportsAPI);
    if (resp) yield put(courierActions.getCourierReportsSuccess(resp.data));
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.getCourierReportsFailure(error));
  }
}

export function* getCourierReport({ payload }) {
  try {
    const resp = yield call(getCourierReportAPI, payload);
    if (resp) yield put(courierActions.getCourierReportSuccess(resp.data));
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.getCourierReportFailure(error));
  }
}

export function* getCourierLiveMonitor() {
  try {
    const resp = yield call(getCourierLiveMonitorAPI);
    if (resp) yield put(courierActions.getCourierLiveMonitorSuccess(resp.data));
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.getCourierLiveMonitorFailure(error));
  }
}

// ---- Optimization (Phase 7) ----
export function* optimizeRoundStops({ payload: roundId }) {
  try {
    const resp = yield call(optimizeCourierRoundStopsAPI, roundId);
    if (resp) {
      yield put(courierActions.optimizeRoundStopsSuccess(resp.data));
      toast.success("Stops optimized");
      yield put(courierActions.getCourierRoundStopsRequest(roundId));
      yield put(courierActions.getCourierRoundsRequest({}));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.optimizeRoundStopsFailure(error));
  }
}

export function* autoAssignCourierTrip({ payload: tripId }) {
  try {
    const resp = yield call(autoAssignCourierTripAPI, tripId);
    if (resp) {
      yield put(courierActions.autoAssignCourierTripSuccess(resp.data));
      toast.success("Courier auto-assigned");
      yield put(courierActions.getCourierTripsRequest({}));
    }
  } catch (error) {
    logger.error(error);
    toastApiError(error);
    yield put(courierActions.autoAssignCourierTripFailure(error));
  }
}
